import { MatIconModule } from '@angular/material/icon';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { SharedModule } from '@shared/shared.module';
import { HeaderNewComponent } from './header-new.component';
import { MatProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { IndicatorComponent } from './components/indicator/indicator.component';
import { AccountMenuComponent } from './components/account-menu/account-menu.component';

import { DropcartComponent } from './components/dropcart/dropcart.component';
import { LinksComponent } from './components/links/links.component';
import { MenuComponent } from './components/menu/menu.component';
import { MegamenuComponent } from './components/megamenu/megamenu.component';
import { NavComponent } from './components/nav/nav.component';

import { MatMenuModule as MatMenuModule } from '@angular/material/menu';
import { MatButtonModule as MatButtonModule } from '@angular/material/button';


@NgModule({
    imports: [
    // modules (angular)
    CommonModule,
    RouterModule,
    ReactiveFormsModule,
    // modules
    SharedModule,
    
    MatIconModule,
    MatMenuModule,
    MatProgressSpinnerModule,
    NgxMatSelectSearchModule,
    MatButtonModule,
    HeaderNewComponent,
    AccountMenuComponent,
    MenuComponent,
    MegamenuComponent,
    IndicatorComponent,
    DropcartComponent,
    LinksComponent,
    NavComponent
],
    exports: [
        HeaderNewComponent
    ]
})
export class HeaderNewModule { }
